import { useBrannanDesignContext } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan/BrannanDesignContext';
import { getBrannanMobileMediaQuery } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan/LayoutBrannan.theme';
import { useMount } from '@shared/utils/hooks/useMount';
import { useBundledApplicatorEnabled } from '@shared/utils/styleApplicator/ThemeStylesProvider';
import { useMediaQuery } from '@withjoy/joykit/utils';

/**
 * Re-runs the legacy style applicator once the lazy-loaded title banner has mounted (small screens only).
 * Side effect: `reapplyDesign()` re-renders the whole Brannan layout, so it is skipped on the bundled path.
 */
export const useReapplyDesignOnMount = (): void => {
  const isSmallScreen = useMediaQuery(getBrannanMobileMediaQuery);
  const { reapplyDesign } = useBrannanDesignContext();
  const isBundledApplicatorEnabled = useBundledApplicatorEnabled();

  useMount(() => {
    // Legacy only: the external applicator targets [data-component="title-banner"], which doesn't
    // exist until this lazy chunk mounts (JOY-9568). The bundled path renders the banner art itself
    // (useTitleBannerCanvas), so re-applying there only re-renders the layout during the mobile LCP window.
    if (isSmallScreen && !isBundledApplicatorEnabled) {
      reapplyDesign();
    }
  });
};
